type RuntimeConfig = {
  VITE_ONE_MEMBER_API_ENDPOINT: string;
  VITE_S3_STORAGE_URL: string;
  VITE_APP_ID: string;
  VITE_MOENGAGE_APP_ID: string;
  VITE_MOENGAGE_PROJECT_ID: string;
  VITE_MOENGAGE_CLUSTER: string;
  VITE_MOENGAGE_DEBUG_LOG: string;
  VITE_MOENGAGE_USE_LATEST: string;
};

const defaultRuntimeConfig: RuntimeConfig = {
  VITE_ONE_MEMBER_API_ENDPOINT: import.meta.env.VITE_ONE_MEMBER_API_ENDPOINT,
  VITE_S3_STORAGE_URL: import.meta.env.VITE_S3_STORAGE_URL,
  VITE_APP_ID: import.meta.env.VITE_APP_ID,
  VITE_MOENGAGE_APP_ID: import.meta.env.VITE_MOENGAGE_APP_ID,
  VITE_MOENGAGE_PROJECT_ID: import.meta.env.VITE_MOENGAGE_PROJECT_ID,
  VITE_MOENGAGE_CLUSTER: import.meta.env.VITE_MOENGAGE_CLUSTER,
  VITE_MOENGAGE_DEBUG_LOG: import.meta.env.VITE_MOENGAGE_DEBUG_LOG,
  VITE_MOENGAGE_USE_LATEST: import.meta.env.VITE_MOENGAGE_USE_LATEST,
};

export const getRuntimeConfig = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const customRuntimeConfig = window.publicRuntimeConfig || {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mergedConfig: any = {
    ...defaultRuntimeConfig,
  };
  for (const key in customRuntimeConfig) {
    const placeholderConfigValue = `{{${key}}}`;
    const configValue = customRuntimeConfig[key];

    if (configValue !== placeholderConfigValue) {
      mergedConfig[key] = configValue;
    }
  }

  return mergedConfig as RuntimeConfig;
};
